import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=4b7947ed&scoped=true&"
import script from "./Participant.vue?vue&type=script&lang=js&"
export * from "./Participant.vue?vue&type=script&lang=js&"
import style0 from "./Participant.vue?vue&type=style&index=0&id=4b7947ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7947ed",
  null
  
)

export default component.exports